import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { SharedModule } from 'src/app/shared/shared.module';
import { SpinnerState } from 'src/app/shared/ui/spinner/redux/spinner.state';
import { SmartCleanService } from '../../services/smart-clean.service';
import { CleanScoreState } from '../redux';
import { LoadSmartCleanRecords, PatchCleanScore, RemoveCleanScore } from '../redux/clean-score.actions';

@Component({
  selector: 'app-create-clean-score',
  templateUrl: './create-clean-score.component.html',
  styleUrls: ['./create-clean-score.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class CreateCleanScoreComponent implements OnInit, AfterViewInit, OnDestroy {
  public smartCleanRecord$: Observable<any> = inject(Store).select(CleanScoreState.smartCleanRecords);
  public loading$: Observable<boolean> = inject(Store).select(SpinnerState.isLoading);
  private unsubscribe = new Subject<void>();

  public Object = Object;
  public spin;
  public cleanScoreRecords = [];
  public selectedMaps: Record<string, any[]> = {};
  public enableSubmit = false;
  public selectedRobots: string[] = [];
  public loadedRobots: string[] = [];

  constructor(private store: Store, private service: SmartCleanService) {
    this.store.dispatch(LoadSmartCleanRecords);
  }

  public ngAfterViewInit(): void {
    this.robotIdClear();
  }

  public ngOnInit(): void {
    this.smartCleanRecord$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data && data.length > 0) {
        this.service.populateFields(data, this.cleanScoreRecords);
        this.loadedRobots = this.selectedRobots;
      }
    });
    this.loading$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.spin = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public onSubmit(): void {
    const recordKeys = this.Object.keys(this.cleanScoreRecords);
    recordKeys.forEach((recordKey) => {
      const scoreKeys = this.Object.keys(this.cleanScoreRecords[recordKey]);
      scoreKeys.forEach((scoreKey) => {
        this.store.dispatch(new PatchCleanScore(this.cleanScoreRecords[recordKey][scoreKey]));
      });
    });
  }
  public onSelectionChange() {
    this.enableSubmit = Object.values(this.selectedMaps).some((arr) => arr.length > 0);
  }
  public robotIdRemove(event) {
    delete this.cleanScoreRecords[event.label];
    delete this.selectedMaps[event.label];
    this.loadedRobots = this.selectedRobots;
  }

  public robotIdAdd(event) {
    this.store.dispatch(new LoadSmartCleanRecords(event.label));
  }

  public robotIdClear() {
    this.store.dispatch(new RemoveCleanScore());
    this.cleanScoreRecords = [];
    this.selectedMaps = {};
    this.loadedRobots = [];
    this.selectedRobots = [];
  }
}
